import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateObjectValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";

import type { MarketingChannelsDescription } from "../../types/description.dto";
import type { IMarketingChannelsFilterDto } from "../../types/leadsSearchFilters.dto";

export default class FindMarketingChannelsFilter extends FilterPanelBaseFilter<
    IMarketingChannelsFilterDto,
    MarketingChannelsDescription
> {
    constructor(deps: IFilterPanelBaseFilterDeps<IMarketingChannelsFilterDto, MarketingChannelsDescription>) {
        super(deps);
    }

    isFilterDirty(currentValue: IMarketingChannelsFilterDto | undefined): boolean {
        return JSON.stringify(this.initialDtoValue ?? {}) !== JSON.stringify(currentValue ?? {});
    }

    calculateValueDelta(
        previousValue: IMarketingChannelsFilterDto | undefined,
        newValue: IMarketingChannelsFilterDto | undefined,
    ): FilterValueDelta<IMarketingChannelsFilterDto> {
        return calculateObjectValueDelta<Partial<IMarketingChannelsFilterDto>>(previousValue, newValue);
    }
}
